import { generateParams } from '@/utils/helpers';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';

import instance from '../instance';

const errorMapper = new ErrorMapper();
const resource = '/spatial';

export default {
  search: async function ({ params = [], token, onDownloadEventHandler = null }) {
    try {
      const paramsString = generateParams(params);
      let config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      if (onDownloadEventHandler) {
        config = Object.assign(config, {
          onDownloadProgress: onDownloadEventHandler,
        });
      }
      return await instance.get(`${resource}/search${paramsString}`, config);
    } catch (error) {
      throw errorMapper.mapToCodeModel(error);
    }
  },
  saveImageFromMap: async function ({ payload, token }) {
    try {
      return await instance.post(`${resource}/save-image`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      throw errorMapper.mapToCodeModel(error);
    }
  },
  getImages: async function ({ token, params = {}, controller = {} } = {}) {
    try {
      const config = {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      if (controller) {
        config.signal = controller.signal;
      }

      return await instance.get(`${resource}/get-images`, config);
    } catch (error) {
      throw errorMapper.mapToCodeModel(error);
    }
  },
};
